import { TextField, TextFieldProps } from "@mui/material";

type AppDateInputProps = Omit<TextFieldProps, "type">;

const AppDateInput = (props: AppDateInputProps) => {
  return (
    <TextField
      fullWidth
      margin="dense"
      type="date"
      slotProps={{ inputLabel: { shrink: true } }}
      {...props}
    />
  );
};

export default AppDateInput;
